
export class PgTotemWidget {
    id:string = null;
    name:string = null;
    title:string = null;
    color:string = null;
    condition:string = null;
    params:any = null;

    static widgetOptions = [{ 
        value: 'totem-widget-text',
        text: 'Text',
        params: {
            abstract: '',
            subAbstract: '',
            logo: '',
            logoInvert: false,
            cover: '',
            text: '',
            background: '',
            abstractColor: '',
            showProducts: false,
            productsFilter: null
        }
    }, { 
        value: 'totem-widget-identity',
        text: 'Identity',
        params: {
            image: '',
            name: '',
            abstract: '',
            description: '',
            contact: ''
        }
    }, { 
        value: 'totem-widget-carousel',
        text: 'Carousel',
        params: {
            imageList: [{ file: '', text: '', author: '' }]
        }
    }, { 
        value: 'totem-widget-products',
        text: 'Products',
        params: {
            filter: null,
            showMap: false,
            showText: null,
            verticalList: false,
            fullScreenView: null
        }
    }, { 
        value: 'totem-widget-weather',
        text: 'Weather',
        params: {
            location: ''
        }
    }, { 
        value: 'totem-widget-visit-card',
        text: 'Visit Card',
        params: {
            text: '',
            image: '',
            video: '',
            videoPoster: '',
        }
    }, { 
        value: 'totem-widget-hero',
        text: 'Hero',
        params: {
            title: '',
            text: '',
            background: '',
            image: '',
            video: '',
            buttons: [{ 
                icon: '', 
                text: '', 
                color: '',
                url: null,
                widget: null
            }]
        }
    }, { 
        value: 'totem-widget-clusters',
        text: 'Clusters',
        params: {
            title: '',
            subtitle: '',
            clusters: [{
                label: '',
                icon: '',
                image: '',
                color: '#f1670f',
                filter: null,
                title: '',
                cover: null,
                description: '',
                video: null,
                videoPoster: null
            }]
        }
    }, { 
        value: 'totem-widget-welcome',
        text: 'Welcome',
        params: {
            title: '',
            text: '',
            background: '',
            image: '',
            links: [{ 
                text: '', 
                color: '',
                url: null,
                widget: null
            }],
            socials: {
                facebook: { url: null, color: null },
                instagram: null,
                whatsapp: null,
                telegram: null
            }
        }
    }]

    constructor(fromData?:any) {
        if(fromData != null) {
            for(let i in fromData) {
                if(typeof this[i] != 'undefined') {
                    this[i] = fromData[i]
                }
            }
        }
    }

    getLabel() {
        let _widgetLabel:string = '';

        for(let _option of PgTotemWidget.widgetOptions) {
            if(_option.value == this.name) {
                _widgetLabel = _option.text;
                break;
            }
        }

        if(this.name == 'totem-widget-products') {
            if(this.params?.showText != null) {
                _widgetLabel += ' - Text'
            }
            else if(this.params?.showMap) {
                _widgetLabel += ' - Map'
            }
            else if(this.params?.verticalList) {
                _widgetLabel += ' - V. List'
            }
            else {
                _widgetLabel += ' - H. List'
            }
        }

        return _widgetLabel;
    }
}

export class PgTotemScreenSaver {
    params:Array<{
        video?:string
        slides?:Array<{
            image:string,
            text:string
        }>
    }>

    images:Array<string>
    videos:Array<string>
    open:boolean
}